export const keyingAll = (
  denominacion: string,
  documento: any,
  tipoDocumento: string,
  typeNumber: string,
  countryCode: string,
  countryName: string,
  profile: string,
  profileId: string,
  identifyType,
  dataKeying?
) => {

  const countryCODE = countryCode.toLocaleUpperCase();

  const countriesNumery = {
    'AR': '032',
    'PY': '600',
    'PE': '604',
    'UY': '858'
  }

  let keyDenomination = "";
  let identifiersGeneral = {
    IDENTIFIER_SSN: "",
    IDENTIFIER_STATEDL: "",
    IDENTIFIER_ORIGIN_COUNTRY_NUMERIC_CODE: countriesNumery[countryCODE],
    IDENTIFIER_ORIGIN_COUNTRY_NAME: countryName.toLocaleUpperCase(),
    IDENTIFIER_ORIGIN_COUNTRY_CODE: countryCODE,
  }
  let identifiers = {}
  let IDENTIFIER_TYPE = 'IDENTIFIER_TYPE';
  let IDENTIFIER_NUMBER = 'IDENTIFIER_NUMBER';

  let identifierType = "";
  let identifierNumber = "";
  let identifierBusinessIDType = "";
  let firstName = "";
  let nameFull = "";
  let data = {
    NAME_MIDDLE_NAME: "",
    NAME_FIRST_NAME: "",
    NAME_PREFIX: "",
    NAME_LAST_NAME: "",
    NAME_SUFFIX: "",
    //NAME_FULL: denominacion,
  }
  if (countryCode === 'AR' && profile === 'CONSUMER') {
    keyDenomination = 'NAME_FULL';
    identifierBusinessIDType = "16";
    identifierType = (tipoDocumento === 'CUIL' || tipoDocumento === 'CUIT') ? "16" : ""
    identifierNumber = (tipoDocumento === 'CUIL' || tipoDocumento === 'CUIT') ? documento : "";
    identifiersGeneral['IDENTIFIER_TYPE_2'] = tipoDocumento === 'DNI' ? "1" : "";
    identifiersGeneral['IDENTIFIER_NUMBER_2'] = tipoDocumento === 'DNI' ? documento : "";
  }

  if (countryCode === 'UY' && profile === 'CONSUMER') {
    identifierType = "1UY";
    identifierNumber = documento || "";
    denominacion = dataKeying.nombre_completo || "";
  }

  if (countryCode === 'PE' && profile === 'CONSUMER') {
    identifierType = "1";
    identifierNumber = dataKeying.documentNum || "";
    denominacion = dataKeying.fullNameNormalized || "";
  }

  if (countryCode === 'AR' && profile === 'COMMERCIAL') {
    identifierBusinessIDType = "16";
    denominacion = dataKeying["denominacion"];
  }
  if (countryCode === 'PY' && profile === 'CONSUMER') {
    identifierType = `${dataKeying.identifyType}${dataKeying.pais_documento_id}`
    identifierNumber = dataKeying.documento;
    keyDenomination = 'NAME_FULL';
    data['NAME_FIRST_NAME'] = dataKeying.primer_nombre;
    data['NAME_MIDDLE_NAME'] = dataKeying.segundo_nombre;
    data['NAME_LAST_NAME'] = dataKeying.primer_apellido;
    data['NAME_SECOND_LAST_NAME'] = dataKeying.segundo_apellido;
    data['NAME_MARRIED_LAST_NAME'] = dataKeying.apellido_casada;
    denominacion = dataKeying.nombre_completo;
    IDENTIFIER_TYPE = 'IDENTIFIER_TYPE' + (parseInt(identifyType) > 1 ? `_${identifyType}` : '')
    IDENTIFIER_NUMBER = 'IDENTIFIER_NUMBER' + (parseInt(identifyType) > 1 ? `_${identifyType}` : '')

  }
  if (countryCode === 'PY' && profile === 'COMMERCIAL') {
    identifierBusinessIDType = "3";
    data['NAME_BUSINESS_NAME'] = dataKeying.razon_social;
    data['NAME_LEGAL_BUSINESS_NAME'] = "";
    identifiersGeneral['IDENTIFIER_BUSINESS_COUNTRY'] = countryCODE;
    identifiersGeneral['IDENTIFIER_BUSINESS_REGISTRATION_DATE'] = "1996-09-10 00:00:00.000";
  }

  if (profile === 'COMMERCIAL') {
    keyDenomination = 'NAME_BUSINESS_NAME';

    identifiers = {
      ...identifiersGeneral,
      IDENTIFIER_BUSINESS_ID: documento,
      IDENTIFIER_BUSINESS_ID_TYPE: identifierBusinessIDType
    }
  } else {
    keyDenomination = 'NAME_FULL';
    identifiers = {
      ...identifiersGeneral,
      [`${IDENTIFIER_TYPE}`]: identifierType,
      [`${IDENTIFIER_NUMBER}`]: identifierNumber
    }
  }

  data[keyDenomination] = denominacion;

  // Enriquecer los campos de names del keying con datos del buscador y del formulario (solo CONSUMER)
  // El buscador (busqueda avanzada) provee NAME_FULL, NAME_FIRST_NAME, NAME_LAST_NAME, etc.
  if (profile !== 'COMMERCIAL') {
    const searcherNames = dataKeying?._searcherNames || {};

    // 1. Volcar cualquier campo NAME_* no vacio provisto por el buscador
    Object.keys(searcherNames).forEach((key) => {
      if (key.startsWith('NAME_')) {
        const value = searcherNames[key];
        if (value !== undefined && value !== null && String(value).trim() !== '') {
          data[key] = value;
        }
      }
    });

    // 2. Fallback: derivar nombre/apellido desde el formulario si no vinieron del buscador
    if (!data['NAME_FIRST_NAME'] && dataKeying?.nombres) {
      data['NAME_FIRST_NAME'] = String(dataKeying.nombres).toLocaleUpperCase();
    }
    if (!data['NAME_LAST_NAME'] && dataKeying?.apellidos) {
      data['NAME_LAST_NAME'] = String(dataKeying.apellidos).toLocaleUpperCase();
    }

    // 3. Garantizar NAME_FULL: preferir el del buscador, si no usar la denominacion generada
    if (!data['NAME_FULL'] || String(data['NAME_FULL']).trim() === '') {
      data['NAME_FULL'] = denominacion;
    }
  }

  let dataGeneral = {
    names: [
      {
        data
      },
    ],
    identifiers,
    addresses: [
      {
        data: {
          ADDRESS_STREET_NAME: "",
          ADDRESS_UNIT_TYPE: "",
          ADDRESS_FIPS_CODE: "",
          ADDRESS_UNIT_NUMBER: "",
          ADDRESS_ZIP5: "",
          ADDRESS_ZIP4: "",
          ADDRESS_CITY: "",
          ADDRESS_STREET_NUMBER: "",
          ADDRESS_STATE: "",
        },
      },
    ],
    phones: {
      PHONE_HOME: "",
      PHONE_OFFICE: "",
      PHONE_PCS: "",
      PHONE_FAX: "",
      PHONE_CHILDREN: "",
      PHONE_PAGER: "",
      PHONE_CELL: "",
      PHONE_OTHERS: "",
    },
    legacyIds: {},
    emails: {
      EMAIL_HOME: "",
    },
    lineageKey: "",
    discoveryData: {},
  };

  let consumer = null;
  let commercial = null;

  if (profile === 'COMMERCIAL') {
    dataGeneral['website'] = {};
    dataGeneral['owners'] = {};
    commercial = dataGeneral;
  } else {
    consumer = dataGeneral;
    dataGeneral['dob'] = {
      DOB_DAY_OF_BIRTH: "",
      DOB_DATE: "",
      DOB_YEAR_OF_BIRTH: "",
      DOB_MONTH_OF_BIRTH: "",
    };
    dataGeneral['gender'] = 0;
  }

  let keying = [
    {
      request: {
        session: {
          quoteback: "",
          customerId: "",
          profileId, //: "dfkl_ar_profile_consumer_docname_exactlyfuzzy_1",
          entityType: profile.toLocaleUpperCase(),
        },
        entity: {
          consumer,
          commercial,
        },
      },
      response: null,
    },
  ];

  return keying;
};
